import { IconType, iconTransformation } from 'lib/ui/icons/index.js';

export class WorkoutHelper {
	getWorkoutIconTypes(): IconType[] {
		return [
			'volleyball',
			'hockey',
			'baseball',
			'bicycle',
			'stopwatch',
			'spa',
			'skiing',
			'skating',
			'tableTennis',
			'running',
			'hiking',
			'americanFootball',
			'soccer',
			'golf',
			'bowling',
			'basketball',
			'swimming',
			'flame'
		];
	}

	getAllIconTypes(): IconType[] {
		return Object.entries(iconTransformation).map((a, b) => a[0] as IconType);
	}
}

export const workoutHelper = new WorkoutHelper();
